import { colorError, colorPrimary } from '@atlas-frontend/design-tokens';
import { Handle, Position } from '@xyflow/react';
import styled from 'styled-components';

export const GraphHandle = styled(Handle)<{ $isInvalid?: boolean }>`
  z-index: 1;
  width: 7px;
  height: 7px;
  border: none;
  background: ${colorPrimary};

  &:after {
    position: absolute;
    content: '';
    width: 25px;
    height: 25px;
    border-radius: 25px;
    left: -9px;
    top: -9px;
    background: ${({ isConnectable }) =>
      isConnectable === false ? 'none' : `${colorPrimary}1a`};
  }

  ${({ $isInvalid, isConnectable }) =>
    $isInvalid
      ? `
  background: ${colorError};

  &:after {
    background: ${isConnectable === false ? 'none' : `${colorError}1a`};
  }
  `
      : ''}

  ${({ position }) =>
    position === Position.Left
      ? `
  left: auto;
  right: 100%;
  transform: translate(3px, -50%);`
      : `
  left: 100%;
  right: auto;
  transform: translate(-3px, -50%);`}
`;
